import { Injectable, Inject } from "@angular/core";
import { AppConfig } from "src/environments/appconfig";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UsuarioActual } from "src/app/util/usuarioactual";
import { UHttpsClient } from "./uhttpsClient";

@Injectable()
export class EmpleadomastServicio {

    private url = `${this.config.getEnv('proxy')}spring/core/empleadomast/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public obtenerUsuarioActual(): Promise<UsuarioActual> {
        return this.http.get(`${this.url}obtenerUsuarioActual`, { headers: this.headers })
            .toPromise()
            .then(response => {
                return response as UsuarioActual;
            })
            .catch(error => null);
    }


}

// export function CONVERTIR_FOTO(d) {
//     if (d === undefined || d == null || d === '') {
//         d = 'user.png';
//     } else {
//         d = 'data:image/jpg;base64,' + d;
//     }
//     return d;
// }
